import { useNavigate } from 'react-router-dom';
import { Button } from '../../components/ui/button';
import { Card, CardContent } from '../../components/ui/card';
import { 
  BookOpen, 
  Award, 
  FileCheck, 
  Briefcase, 
  HeartHandshake, 
  Plane,
  ChevronRight 
} from 'lucide-react';

const services = [
  {
    icon: BookOpen,
    title: "Cours d'allemand A1–C1",
    description: "Expertise pédagogique. Professeurs certifiés Goethe/TELC/ECL. Progression rapide garantie.",
    color: "bg-primary"
  },
  {
    icon: Award,
    title: "Préparation Goethe/TELC/ECL",
    description: "Entraînement ciblé pour réussir vos certifications officielles.",
    color: "bg-secondary"
  },
  {
    icon: FileCheck,
    title: "Montage de dossiers visa",
    description: "Accompagnement complet pour constituer un dossier solide et conforme.",
    color: "bg-accent"
  },
  {
    icon: Briefcase,
    title: "Orientation professionnelle",
    description: "Conseil personnalisé pour choisir la filière adaptée à vos objectifs.",
    color: "bg-primary"
  },
  {
    icon: HeartHandshake,
    title: "Coaching d'intégration",
    description: "Parcours métier intégré. Vocabulaire professionnel, mise en situation réelle, préparation aux codes culturels allemands.",
    color: "bg-secondary"
  },
  {
    icon: Plane,
    title: "Accompagnement jusqu'à l'arrivée",
    description: "Package complet de tous les services précédents. Suivi individuel, alignement avec les besoins réels du marché allemand, recommandations personnalisées.",
    color: "bg-accent"
  }
];

const ServicesSection = () => {
  const navigate = useNavigate();

  return (
    <section id="services" className="py-16 md:py-24 bg-[#f9fafb] relative overflow-hidden" data-testid="services-section">
      {/* Subtle dot pattern background */}
      <div 
        className="absolute inset-0 opacity-100" 
        style={{ 
          backgroundImage: 'radial-gradient(circle, rgba(204,0,126,0.03) 1px, transparent 1px)', 
          backgroundSize: '24px 24px' 
        }} 
      />
      
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative">
        {/* Section Header */}
        <div className="text-center mb-12 md:mb-16">
          <span className="inline-block px-4 py-1.5 rounded-full bg-secondary/10 text-secondary text-sm font-medium mb-4">
            Nos services
          </span>
          <h2 className="font-heading text-3xl sm:text-4xl font-bold text-gray-900 mb-4">
            Tout pour concrétiser votre projet ?
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Un accompagnement structuré, sérieux et complet pour réussir votre avenir en Allemagne.
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 max-w-5xl mx-auto">
          {services.map((service, index) => (
            <Card 
              key={index} 
              className="group border border-gray-100 shadow-sm hover:shadow-lg transition-all duration-300 hover:-translate-y-1 bg-white overflow-hidden rounded-2xl"
              data-testid={`service-card-${index}`}
            >
              <CardContent className="p-6">
                {/* Icon centered */}
                <div className="mb-6 h-20 flex items-center justify-center">
                  <div className={`w-16 h-16 rounded-2xl ${service.color} flex items-center justify-center group-hover:scale-110 transition-transform`}>
                    <service.icon className="w-8 h-8 text-white" />
                  </div>
                </div>
                
                {/* Title */}
                <h3 className="font-heading text-lg font-bold text-gray-900 mb-2 text-center">
                  {service.title}
                </h3>
                
                {/* Description */}
                <p className="text-gray-500 text-sm leading-relaxed text-center">
                  {service.description}
                </p>
              </CardContent>
            </Card>
          ))}
        </div>

        {/* CTA */}
        <div className="text-center mt-12">
          <Button 
            size="lg"
            onClick={() => navigate('/register')}
            className="bg-secondary hover:bg-secondary/90 px-8"
            data-testid="services-cta"
          >
            Découvrir nos programmes
            <ChevronRight className="w-5 h-5 ml-2" />
          </Button>
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
